import { Controller } from "@hotwired/stimulus";
import {
  installSanitationRouteHistoryGuard,
  localRouteIdFromLocation,
} from "../routeNavigation.js";

// Blocks PWA/browser swipe-back on in-progress route screens. Swipe-back can
// restore a stale checkpoint from history/bfcache that no longer matches
// IndexedDB — monitors must leave via the pause button instead.
//
// Connects to data-controller="sanitation-route-history-guard"
export default class extends Controller {
  static values = {
    message: String,
  };

  connect() {
    if (!localRouteIdFromLocation()) return;

    this.teardownGuard = installSanitationRouteHistoryGuard({
      message:
        this.messageValue ||
        "Para salir del recorrido usa el botón de pausa. Volver atrás puede mostrar un paso anterior.",
    });
  }

  disconnect() {
    this.teardownGuard?.();
    this.teardownGuard = null;
  }
}
